import { render } from "./BlueBlock.vue?vue&type=template&id=47e88e6a&scoped=true"
import script from "./BlueBlock.vue?vue&type=script&lang=js"
export * from "./BlueBlock.vue?vue&type=script&lang=js"

import "./BlueBlock.vue?vue&type=style&index=0&id=47e88e6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e88e6a"]])

export default __exports__